module.exports = __webpack_public_path__ + "static/media/media.ab4b0358.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/media.svg
// module id = 124
// module chunks = 1